<template>
<div id="app-wrapper">
    <template v-if="$route.meta.otherLayout === false">
        <div id="pcoded" class="pcoded">
            <theme-loader></theme-loader>
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">
                <app-navbar></app-navbar>
                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        <app-drawer :level-path="levelPath" :scope="scope"></app-drawer>
                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <!-- Main-body start -->
                                <main class="main-body">
                                    <div class="page-wrapper">
                                        <page-header v-if="$route.meta.title"></page-header>
                                        <div class="page-body">
                                            <div v-if="!$route.meta.manualLayout" class="row">
                                                <div class="col-sm-12">
                                                    <div class="card">
                                                        <div class="card-header py-3">
                                                            <h5 v-if="$route.meta.cardTitle">{{ $route.meta.cardTitle }}</h5>
                                                            <span v-if="$route.meta.cardSubTitle">{{ $route.meta.cardSubTitle }}</span>
                                                            <div class="card-header-right">
                                                                <ul class="list-unstyled card-option">
                                                                    <li><i class="feather icon-maximize full-card"></i></li>
                                                                    <li><i class="feather icon-minus minimize-card"></i></li>
                                                                    <li><i class="feather icon-trash-2 close-card"></i></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="card-block">
                                                            <router-view :scope="scope"></router-view>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <router-view v-else-if="$route.meta.manualLayout" :scope="scope"></router-view>
                                        </div>
                                    </div>
                                </main>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-else-if="$route.meta.otherLayout === true">
        <div>
            <!-- <transition>
            <keep-alive> -->
            <theme-loader></theme-loader>
            <router-view :key="$route.fullpath"></router-view>
            <!-- </keep-alive>
            </transition> -->
        </div>
    </template>
    <template v-else>
        <div>
            <theme-loader></theme-loader>
        </div>
    </template>
</div>
</template>

<script>
import AppNavbar from '@/components/layouts/AppNavbar.vue';
import AppDrawer from '@/components/layouts/AppDrawer.vue';
import ThemeLoader from '@/components/layouts/ThemeLoader.vue';
import PageHeader from '@/components/layouts/PageHeader.vue';

import TemplateSetting from '@/template-setting';

import {
    getToken,
    isLoggedIn
} from '@/services/auth-service';

// import {refreshToken} from '@/services/auth-service';

export default {
    components: {
        AppNavbar,
        AppDrawer,
        ThemeLoader,
        PageHeader
    },
    data () {
        return {
            beforeOtherLayout: null,
            levelPath: [],
            scope: null
        };
    },
    created () {
        // refreshToken();
        this.jquerySetup();
    },
    mounted () { // Before Dom
        require('@/assets/js/jquery.slimscroll');
        require('@/assets/js/pcoded.min');
        require('@/assets/js/jquery.autocomplete');
    },
    updated () { // Dom finish
        this.checkPage();
    },
    watch: {
        $route (to, from) {
            this.scope = getToken() ? getToken().user.scope : null;
            let thisPath = to.path;
            while(thisPath.charAt(0) === '/') {
                thisPath = thisPath.substr(1);
            }
            this.levelPath = thisPath.split('/');
        }
    },
    methods: {
        checkPage() {
            let otherLayout = this.$route.meta.otherLayout
            if (this.beforeOtherLayout !== otherLayout) {
                if (otherLayout === false) {
                    TemplateSetting();
                } else {
                    $('.theme-loader').fadeOut('slow', function() {
                        $(this).remove();
                    });
                }
            }
            this.beforeOtherLayout = otherLayout;
        },
        jquerySetup() {
            let _this = this;
            $('body').on('click', '.app-copy-text', function(e) {
                e.preventDefault();
                let attr = $(this).attr('data-copy');
                let copy = $(this).text();
                if (typeof attr !== 'undefined' && attr !== false) {
                    copy = attr;
                }
                _this.appCopyText(copy);
            });
        },
        appCopyText(text) {
            navigator.clipboard.writeText(text);
        },
    }
};
</script>
